import { render, staticRenderFns } from "./loyaltyPointsUpdates.vue?vue&type=template&id=742c8ef0&"
import script from "./loyaltyPointsUpdates.vue?vue&type=script&lang=js&"
export * from "./loyaltyPointsUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports